import ContactForm from '@/components/ContactForm';
import SectionTitle from '@/components/SectionTitle';

// Llamado final: título con líneas, texto breve y un solo botón (como "Un sinfín de posibilidades" en nido.cl)
export default function JoinUsSection() {
  return (
    <section className="w-full bg-white py-14 md:py-20">
      <div className="container mx-auto px-6 md:px-8">
        <SectionTitle>Únete a nuestra comunidad</SectionTitle>
        <div className="mx-auto mt-8 flex max-w-2xl flex-col items-center text-center">
          <img
            src="/01-images/milenito.webp"
            alt="Milenito - Mascota del Colegio Nuevo Milenio"
            loading="lazy"
            width="150"
            height="150"
            className="h-32 w-32 object-contain"
          />
          <p className="mt-4 text-gray-600 leading-relaxed">
            En Colegio Nuevo Milenio, creemos en el potencial de cada estudiante.
            ¡Sé parte de nuestra familia educativa!
          </p>
          <div className="mt-8">
            <ContactForm variant="default" />
          </div>
        </div>
      </div>
    </section>
  );
}
